module.exports = __webpack_public_path__ + "images/d6f349fa7ecb3674702ac83dfc885761.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/trophy.png
// module id = 360
// module chunks = 0